<ng-template #content let-modal>

    <div class="modal-header bg-dark">
        <h5 class="modal-title" id="addPaymentLabel">Agregar metodo de pago</h5>
        <button type="button" class="close text-light" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="paymentForm">
        <div class="modal-body">
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <app-datepicker idForm="InputFechaPago" label="Fecha Pago" [readOnly]="true"
                        [control]="paymentForm.get('fecha_pago')" size="lg" [withTime]="true"
                        [bsValue]="paymentForm.get('fecha_pago')?.value"></app-datepicker>
                </div>
                <div class=" col-md-12">
                    <app-select label="Tipo Pago" size="lg" idForm="InputTipoPago" [data]="tipoPago"
                        optValue="id_tipopago" optText="nombre_tipopago"
                        (returnSelectedText)="paymentForm.get('tipoPagoText')?.setValue($event)"
                        [control]="paymentForm.get('id_tipopago')"></app-select>
                </div>
                <div class="col-md-12">
                    <app-input type="text" label="Nro Documento" size="lg" idForm="InputReferencia"
                        placeholder="Ingresar referencia" [autocomplete]="false"
                        [control]="paymentForm.get('referencia')"></app-input>
                </div>
                <div class="col-md-12">
                    <app-input type="text" label="Total venta" size="lg" idForm="InputValor"
                        placeholder="Ingresar referencia" [autocomplete]="false" iconPrepend="fas fa-dollar-sign"
                        [control]="paymentForm.get('total')" (input)="onlyNumber($event)"></app-input>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" name="add" class="btn btn-outline-success" (click)="modal.close(paymentForm.value)"
                [disabled]="!paymentForm.valid">
                <i class="fas fa-credit-card"></i> Agregar
            </button>
            <button type="button" class="btn btn-outline-danger" (click)="modal.dismiss('close')"><i
                    class="fas fa-times"></i> Cancelar</button>
        </div>
    </form>
</ng-template>

<button *ngIf="onlyIcon" type="button" class="btn btn-outline-success {{cssClass}}" (click)="open(content)">
    <app-popover [classIcon]="'fas fa-credit-card'" [message]="'Agregar metodo de pago'" ngClass="pr-1"></app-popover>
</button>
<button *ngIf="!onlyIcon" type="button" class="btn btn-outline-light btn-block btn-lg  {{cssClass}}"
    (click)="open(content)">
    <i class="fas fa-credit-card"></i> Agregar metodo de pago
</button>